import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { isAdminArea, homeFor } from "@/lib/adminAccess";

export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream">
                <Loader2 className="w-8 h-8 text-brand animate-spin" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (role === "user" && user.email_verified === false) {
        return <Navigate to="/dashboard/verify" state={{ email: user.email }} replace />;
    }
    // The admin area is for the owner (admin) and workers (staff). Workers only see their sections (AdminLayout).
    if (role === "admin" && !isAdminArea(user)) {
        return <Navigate to="/dashboard" replace />;
    }
    if (role && role !== "admin" && user.role !== role) {
        return <Navigate to={homeFor(user)} replace />;
    }
    return children;
}
